import { Add } from '@mui/icons-material';

export default function NewSavedListButton({ onClick, disabled = false }) {
    return <button type='button' className='savedListNewListButton' aria-label='Create new list' disabled={disabled} onClick={onClick}>
        <Add aria-hidden='true' />
        <span>New</span>
    </button>;
}
